import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Snackbar } from "@mui/material";

export function CalibrationRestoredSnackbar({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        variant="filled"
        severity="info"
        onClose={onClose}
        sx={{ width: "100%" }}
      >
        {t("message.calibrate.draft_restored")}
      </Alert>
    </Snackbar>
  );
}
